// extracted by css-extract-rspack-plugin
export default {"SidebarContentTitle":"TAwjO"};